<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="model.id ? '编辑故障分组' : (pageType ? '新建一级故障分组' : '新建故障分组')"
      width="500px"
      top="5vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-form-item label="分组名称" prop="name">
        <el-input v-model="model.name" placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>
<script>
  export default {
    name:"FaultGroupEdit",
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false, 
        pageType: 0,
        model: {
          id: "",
          parentID: "",
          name: "",
        },
        ruleValidate: {
          name: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(parentId, id, name, pageType) {
        console.log(parentId + "," + id + "," + name + "," + pageType);
        this.dialogVisible = true;
        this.model.id = id;
        this.model.parentID = parentId;
        this.model.name = name;
        this.pageType = pageType;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            let params;
            if (this.model.id) {
              params = {
                id: this.model.id,
                name: this.model.name,
                parentID: this.model.parentID,
              };
            } else {
              params = {
                parentID: this.model.parentID ? this.model.parentID : 0,
                name: this.model.name,
              };
            }
            this.$http.save("basic", "faultGroups", params)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$message.success("保存成功");
                this.$emit("save-success");
              })
              .catch(() => {
                this.submitLoading = false;
                this.$message.error("保存失败");
              });
          }
        });
      },
    },
  };
</script>

<style scoped>

</style>